var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-card__title",class:_vm.data.staticClass || _vm.data.class},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.data.domProps && _vm.data.domProps.textContent))]}),(_vm.slots().caption)?_c('span',{staticClass:"b2b-card__title__caption"},[_vm._t("caption")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }